import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";
import { CgFacebook } from "react-icons/cg";
import { ImTwitter } from "react-icons/im";
import { FaInstagram } from "react-icons/fa";

const FormSession = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>First Name</label>
          <input placeholder="Enter your first name" />
        </div>
        <div>
          <label>Last Name</label>
          <input placeholder="Enter your last name" />
        </div>
        <div>
          <label>Email</label>
          <input placeholder="Enter your email" />
        </div>
        <div>
          <label>Phone Number</label>
          <input placeholder="Enter your number" />
        </div>
      </InputContainer>
      <div className="message__input">
        <label>Message</label>
        <label>Enter your message</label>
        <textarea></textarea>
      </div>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/contact"
        >
          Submit
        </Button>
      </div>
      <div className="footer__info"> 
        <p style={{ color: "#C4C4C4", marginTop: "2rem" }}>Email Us</p>
        <p>info@invest-trustltd.com</p>
        <p>(+234) 908 8971 301</p>
        <ContactIcon>
          <Link to="/">
            <CgFacebook size={23} />
          </Link>
          <Link to="/">
            <ImTwitter size={23} />
          </Link>
          <Link to="/">
            {" "}
            <FaInstagram size={23} />
          </Link>
        </ContactIcon>
        <p>© Copyright 2021 Invest-Trust Limited. All Rights Reserved.</p>
      </div>
    </FormContainer>
  );
};

export default FormSession;

export const FormContainer = styled.div`
  font-size: 20px;
  padding-left: 114px;
  div label {
    display: block;
  }
  .message__input textarea {
    font-size: 16px;
    color: red;
    margin-top: 1rem;
    margin-bottom: 24px;
    border: none;
    outline: none;
    border-bottom: 1px solid #c4c4c4;
    width: 90%;
    height: 1rem;
    transform: translateY(-1rem);
  }

  div a {
    color: ${({ theme }) => theme.colors.primary};
  }
  p:last-child {
    text-align: center;
  }

  .message__input label:nth-of-type(2) {
    margin-top: 1rem;
    color: #c4c4c4;
    font-size: 16px;
  }

  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    padding-left: 1rem;

    .message__input label:nth-of-type(2) {
      margin-top: 1rem;
    }
    .message__input textarea {
      //   font-size: px;
      color: #c4c4c4;
      margin-top: 1rem;
      margin-bottom: 24px;
      border: none;
      outline: none;
      border: 1px solid #c4c4c4;
      width: 95%;
      background-color: #ececec;
      border-radius: 8px;
      height: 195px;
    }
    .submit__button {
      display: flex;
      justify-content: center;
    }
    .footer__info {
      display: none;
    }
  }
`;

export const InputContainer = styled.div`
  margin-right: 2rem;
  margin-left; 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  // gap: 2rem;
  label {
    display: block;
  }
  input {
    font-size: 16px;
    color: #c4c4c4;
    opacity: 0.5;
    margin-top: 1rem;
    margin-bottom: 24px;
    border: none;
    outline: none;
    border-bottom: 1px solid #c4c4c4;
    padding-right: 2rem;
    width: 60%;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    input {
    }
  }
  @media screen and (max-width: 579px) {
      input{
          width: 95%;
      }
  }
`;
export const ContactIcon = styled.div`
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  gap: 40px;
`;
